const EMAIL_REGEX = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
const POSTAL_CODE_REGEX = /^[A-Z]\d[A-Z] ?\d[A-Z]\d$/i

export { EMAIL_REGEX, POSTAL_CODE_REGEX }